import { AxiosPromise } from "axios";
import { anonymousApi, authorizedApi, BaseApi } from "../../shared/api/BaseApi";
import { MeetingParticipantDto } from "./api/MeetingParticipantDto";
import { UserStatusDto } from "./api/UserStatusDto";
import { msTeamsMeetingRolesEnum } from "../enum/msTeamsMeetingRolesEnum";

export interface MeetingParticipant {
    role: msTeamsMeetingRolesEnum;
}

export interface UserStatus {
    hasEnoughOneDriveSpaceToRecord: boolean;
    organizerIsRecording: boolean;
}

export interface MeetingType {
    meetingType: number | null;
}

export interface MeetingTypeDictionaryEntry {
    key: string;
    value: number;
}

export interface InMeetingAppService {
    getParticipantData(meetingId: string): AxiosPromise<MeetingParticipantDto>;
    getUserStatus(meetingId: string): AxiosPromise<UserStatusDto>;
    setMeetingType(meetingId: string, meetingType: MeetingType): AxiosPromise;
    getMeetingTypeDictionary(language: string): AxiosPromise<MeetingTypeDictionaryEntry[]>;
}

export class DefaultInMeetingAppService implements InMeetingAppService {
    private meetingsBotBaseUrl: string = "/bot/meetings";

    constructor(private authorizedApi: BaseApi, private anonymousApi: BaseApi) {}

    getParticipantData(meetingId: string): AxiosPromise<MeetingParticipantDto> {
        const encodedMeetingId = encodeURIComponent(meetingId);
        return this.authorizedApi.get<MeetingParticipantDto>(`${this.meetingsBotBaseUrl}/${encodedMeetingId}/me`, {});
    }

    getUserStatus(meetingId: string): AxiosPromise<UserStatusDto> {
        const encodedMeetingId = encodeURIComponent(meetingId);
        return this.authorizedApi.get<UserStatusDto>(`${this.meetingsBotBaseUrl}/${encodedMeetingId}/me/status`, {});
    }

    setMeetingType(meetingId: string, meetingType: MeetingType): AxiosPromise {
        const encodedMeetingId = encodeURIComponent(meetingId);
        return this.authorizedApi.post<MeetingType>(
            `${this.meetingsBotBaseUrl}/${encodedMeetingId}/types`,
            meetingType
        );
    }

    getMeetingTypeDictionary(language: string): AxiosPromise<MeetingTypeDictionaryEntry[]> {
        return this.authorizedApi.get<MeetingTypeDictionaryEntry[]>(
            `${this.meetingsBotBaseUrl}/types?language=${language}`,
            {}
        );
    }
}

export class InMeetingAppServiceWithResponse implements InMeetingAppService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    getParticipantData() {
        return Promise.resolve(this._response);
    }

    getUserStatus() {
        return Promise.resolve(this._response);
    }

    setMeetingType() {
        return Promise.resolve(this._response);
    }

    getMeetingTypeDictionary() {
        return Promise.resolve(this._response);
    }
}

export default new DefaultInMeetingAppService(authorizedApi, anonymousApi);
